export const SETTINGS_LANGUAGE = 'SETTINGS_LANGUAGE';
export const STORAGE_DATAS = 'STORAGE_DATAS';